// src/components/layouts/Sidebar.jsx
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  FaHome, 
  FaSearch, 
  FaChild, 
  FaCalendarAlt, 
  FaBriefcase, 
  FaClock,
  FaIdCard,
  FaUserFriends,
  FaListAlt,
  FaUserEdit,
  FaRegLightbulb
} from 'react-icons/fa';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { currentUser, userType } = useAuth();
  const location = useLocation();

  // If no user is logged in, don't show the sidebar
  if (!currentUser) return null;
  
  return (
    <aside className={`sidebar ${isOpen ? 'active' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <h2 className="interactive-element">TotsPal</h2>
        </div>
        <button className="sidebar-close interactive-element" onClick={toggleSidebar}>
          <span>&times;</span>
        </button>
      </div>

      <div className="sidebar-content">
        <div className="section-label">QUICK LINKS</div>
        <nav className="sidebar-nav">
          {/* SpotLight tab for all users */}
          <NavLink to="/spotlight" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
            <FaRegLightbulb className="nav-icon" />
            <span>SpotLight</span>
          </NavLink>
          
          {userType === 'parents' && (
            <>
              <NavLink to="/parent" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'} end>
                <FaHome className="nav-icon" />
                <span>Dashboard</span>
              </NavLink>
              <NavLink to="/parent/search/providers" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaSearch className="nav-icon" />
                <span>Find Childcare</span>
              </NavLink>
              <NavLink to="/parent/search/jobseekers" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaUserFriends className="nav-icon" />
                <span>Find Caregivers</span>
              </NavLink>
              <NavLink to="/parent/children" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaChild className="nav-icon" />
                <span>My Children</span>
              </NavLink>
              <NavLink to="/parent/jobs" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaBriefcase className="nav-icon" />
                <span>Post Jobs</span>
              </NavLink>
              <NavLink to="/parent/waitlists" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaListAlt className="nav-icon" />
                <span>Waitlists</span>
              </NavLink>
              <NavLink to={`/parent/profile/${currentUser?.uid}`} className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaUserEdit className="nav-icon" />
                <span>Edit Profile</span>
              </NavLink>
              {/* <NavLink to="/parent/appointments" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaCalendarAlt className="nav-icon" />
                <span>Appointments</span>
              </NavLink> */}
            </>
          )}

          {userType === 'providers' && (
            <>
              <NavLink to="/provider" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'} end>
                <FaHome className="nav-icon" />
                <span>Dashboard</span>
              </NavLink>
              <NavLink to="/provider/spots" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaListAlt className="nav-icon" />
                <span>Manage Spots</span>
              </NavLink>
              <NavLink to="/provider/jobs" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaBriefcase className="nav-icon" />
                <span>Post Jobs</span>
              </NavLink>
              <NavLink to="/provider/waiting-list" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaClock className="nav-icon" />
                <span>Waiting List</span>
              </NavLink>
              <NavLink to="/provider/search/children" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaChild className="nav-icon" />
                <span>Find Children</span>
              </NavLink>
              <NavLink to="/provider/profile" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaUserEdit className="nav-icon" />
                <span>Edit Profile</span>
              </NavLink>
            </>
          )}

          {userType === 'jobseekers' && (
            <>
              <NavLink to="/jobseeker" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'} end>
                <FaHome className="nav-icon" />
                <span>Dashboard</span>
              </NavLink>
              <NavLink to="/jobseeker/jobs" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaBriefcase className="nav-icon" />
                <span>Find Jobs</span>
              </NavLink>
              <NavLink to={`/jobseeker/profile/${currentUser?.uid}`} className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
                <FaUserEdit className="nav-icon" />
                <span>Edit Profile</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="section-label">ACCOUNT</div>
        <nav className="sidebar-nav">
          <NavLink to="/messages" className={({ isActive }) => isActive ? 'nav-link active interactive-element' : 'nav-link interactive-element'}>
            <FaUserFriends className="nav-icon" />
            <span>Messages</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <p>© {new Date().getFullYear()} TotsPal</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;